import { contactInfo } from '@/mocks/home';

export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-[800px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            {contactInfo.title}
          </h2>
          <p className="text-sm text-foreground-500">{contactInfo.description}</p>
        </div>
        <div className="bg-background-50 rounded-2xl border border-secondary-200/40 p-8 md:p-10">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-8">
            <div className="flex items-center gap-4 p-4 rounded-xl bg-background-100">
              <div className="w-10 h-10 rounded-xl bg-primary-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-mail-line text-lg text-primary-600"></i>
              </div>
              <div>
                <p className="text-xs text-foreground-400 mb-0.5">投稿邮箱</p>
                <p className="text-sm font-medium text-foreground-800">{contactInfo.email}</p>
              </div>
            </div>
            <div className="flex items-center gap-4 p-4 rounded-xl bg-background-100">
              <div className="w-10 h-10 rounded-xl bg-accent-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-wechat-line text-lg text-accent-700"></i>
              </div>
              <div>
                <p className="text-xs text-foreground-400 mb-0.5">微信联系</p>
                <p className="text-sm font-medium text-foreground-800">{contactInfo.wechat}</p>
              </div>
            </div>
          </div>
          <div className="flex items-center justify-center gap-2 text-sm text-foreground-500">
            <i className="ri-time-line"></i>
            <span>{contactInfo.response}</span>
          </div>
        </div>
      </div>
    </section>
  );
}